var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filters-button',{staticClass:"filters-time-range",attrs:{"icon":_vm.info.icon,"text":`${_vm.info.title} (${_vm.time_start} - ${_vm.time_end})`,"active":_vm.current_filter === _vm.filter_id},on:{"click":_vm.handle_filter_click}})
}
var staticRenderFns = []

export { render, staticRenderFns }